<template>
  <div class="ap">
    <!-- <Messages /> -->
    <!--<aside
      :style="moduleCatalogStyle"
      class="module-catalog justify-end align-center layout column fill-height"
      @mouseenter="catalog.mini = false"
      @mouseleave="catalog.mini = true"
    >
      <div
        v-show="!catalog.mini"
        class="module"
      >
        <div class="module-button layout column align-center">
          <div>ii</div>
        </div>
        <div class="module-button layout column align-center">
          <div>sc</div>
        </div>
      </div>
    </aside>-->
    <v-app id="platform_app" light :style="applicationStyle">
      <v-fade-transition>
        <v-progress-linear v-show="isLoading" indeterminate class="loading-bar" />
      </v-fade-transition>
      <base-dialog v-if="$route.query.dialog" @close="$router.push({ query: { dialog: null } })" />
      <alert :message="notification.msg" :type="notification.type" :open="openAlert" />
      <navigation-component>
        <v-navigation-drawer mini-variant clipped />

        <template slot="sub-navigation">
          <router-view name="sub-navigation" />
        </template>
      </navigation-component>
      <!-- <toolbar-component></toolbar-component> -->
      <resource-dialog />

      <dialog-container v-if="roles.length > 0" :roles="roles" />
      <modal-container />
      <localization-wizard />
      <localization-wizard-compare />
      <v-content :style="contentStyle" class="ma-0" app>
        <boundary :product="product" :country="country">
          <template v-slot:content>
            <base-info-container />

            <asset-overlay v-if="$route.query.asset" />
            <router-view />

            <transition name="component-fade" mode="out-in" />
          </template>
        </boundary>
      </v-content>
    </v-app>
  </div>
</template>

<script>
import NavigationComponent from '@/components/navigation/NavigationComponent';
import { mapState } from 'vuex';
import DialogContainer from '@/components/dialogs/DialogContainer';
import ModalContainer from '@/components/dialogs/ModalContainer';
import Alert from '@/components/alert/Alert';
import ResourceDialog from '@/components/dialogs/ResourceDialog';
import socket from '@/mixins/socket';
import icons from '@/mixins/icons';
import AssetOverlayVue from '../components/overlays/AssetOverlay.vue';
import BaseDialogVue from '../components/core/views/dialogs/BaseDialog.vue';
import BaseInfoContainer from '../components/core/info/base-info-container';
import LocalizationWizard from '../components/localization/localization-wizard';
import LocalizationWizardCompare from '../components/localization/localization-wizard-compare';
import ProductCountryBoundary from '../hoc/ProductCountryBoundary.vue';

export default {
  name: 'Platform',
  components: {
    LocalizationWizardCompare,
    LocalizationWizard,
    BaseInfoContainer,
    baseDialog: BaseDialogVue,
    Alert,
    DialogContainer,
    NavigationComponent,
    ModalContainer,
    ResourceDialog,
    assetOverlay: AssetOverlayVue,
    boundary: ProductCountryBoundary
  },
  mixins: [socket, icons],
  props: {
    product: {
      type: String
    },
    country: {
      type: String
    }
  },
  data() {
    return {
      catalog: {
        mini: true
      }
    };
  },

  created() {
    if (this.isLoggedIn) {
      this.$ga.enable();
    }
  },
  computed: {
    applicationStyle() {
      return {
        paddingLeft: 0
      };
    },
    moduleCatalogStyle() {
      return {
        width: this.catalog.mini ? '4px' : '60px',
        color: this.$vuetify.theme.themes.light.primary,
        backgroundColor: this.$vuetify.theme.themes.light.primary
      };
    },
    contentStyle() {
      return {
        paddingTop: this.$store.getters['localization/isMaster'] ? '43px' : '0px'
      };
    },
    ...mapState('navigation', {
      mini: state => state.mini
    }),
    ...mapState({
      isLoading: state => state.isLoading
    }),
    ...mapState('auth', {
      isLoggedIn: state => state.isLoggedIn
    }),
    ...mapState('alerts', {
      openAlert: state => state.open,
      notification: state => state.notification
    }),
    ...mapState('user', {
      roles: state => state.me.roles || []
    })
  }
};
</script>
<style scoped>
.loading-bar {
  position: fixed;
  top: 0;
  width: 100vw;
  z-index: 10000;
}
</style>
<style>
body {
  overflow-y: hidden !important;
  overflow-x: hidden !important;
}

.full-height {
  height: 100%;
  position: relative;
}
.full {
  width: 100% !important;
  height: 100% !important;
}
.no-shadow {
  box-shadow: none !important;
}
.asset-title {
  font-family: 'Roboto', sans-serif;
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.13;
  letter-spacing: normal;
  color: #4a4a4a;
}
.externalId,
.updated,
.created {
  font-family: 'Roboto', sans-serif;
  font-size: 12px;
  font-weight: 500;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  color: #9b9b9b;
}

:root {
  --dark-sky-blue: #5ca2d2;
  --new-blue: #00416e;
  --watermelon: #ef4d55;
  --divider: rgba(0, 0, 0, 0.12);
  --red: #f34757;
  --dark: #3f3f3e;
  --blue: #54a4d0;
  --warm-grey: #9b9b9b;
  --Dark-grey: #3f3f3e;
  --cornflower-blue: #5ca2d2;
  --watermelon: #ef4d55;
  --Light-grey1: #f4f4f4;
  --Light-grey2: #f9f9f9;
  --dark-blue: #116aa6;
  --white: #ffffff;
  --backlog: rgba(0, 65, 110, 1);
  --backlog-light: #ced9e2;
  --in_progress: rgba(247, 104, 104, 1);
  --in_progress-light: #fde1e1;
  --approval: rgba(255, 195, 101, 1);
  --approval-light: #fff3e2;
  --done: rgba(126, 156, 98, 1);
  --done-light: #e5ebe1;
  --archive: rgba(17, 106, 166, 1);
  --archive-light: rgba(17, 106, 166, 0.2);
  --saved: #61219b;
  --white-two: #e7e7e7;
  --secondary-grey: #cbcbcb;
  --light-form-bg: rgba(0, 0, 0, 0.04);
  --input-bg: rgba(0, 0, 0, 0.04);
  --3: #f34757;
  --2: #f39c1f;
  --1: #54a4d0;
  --0: #89ca47;
  --charcoal: #3f3f3e;
  --seafoam-blue: #64d9cb;
  --sky-blue: #68adf7;
  --soft-green: #5fcf96;
  --butterscotch: #f4b756;
  --salmon: #ed736d;
  --lightish-blue: #4561f3;
}

/* globals */
</style>
<style scoped>
#platform_app {
  -webkit-transition: padding 100ms ease-out;
  -moz-transition: padding 100ms ease-out;
  -o-transition: padding 100ms ease-out;
  transition: padding 100ms ease-out;
}

.component-fade-enter-active,
.component-fade-leave-active {
  transition: opacity 0.2s ease;
}
.component-fade-enter, .component-fade-leave-to
/* .component-fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
</style>
